module.exports = __webpack_public_path__ + "img/lqsx_2.2d3054d5.svg";